import React from 'react';
import { inject, observer } from 'mobx-react';
import VirtualizedList from '../common/VirtualizedList';
import { Segment, Header } from 'semantic-ui-react';

export default inject('store')(observer(props => {
  const { items, onClickItem } = props
  const rowRenderer = ({ index, key, parent, style }) => {
    const op = items[index]
    return(
      <Segment vertical
        key={key}
        onClick={event => onClickItem({ 
          event: event,
          index: index,
          rowData: op 
        })} 
        style={style}
      >
        <Header size='small'>{op.description}</Header>
        Setup: {op.setupTimeAsString}&emsp;Op: {op.operationTimeAsString}
      </Segment>
    )
  }
  return <VirtualizedList
    rowHeight={62}
    rowRenderer={rowRenderer}
    {...props}
  />
}))


// WEBPACK FOOTER //
// ./src/components/standard-operations/StandardOperationList.js